/**
 * @generated SignedSource<<f63c16c6b424583d2630111d739cfce3>>
 * @relayHash 088fa0474e59f1445e2d4ee7d40d296b
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5b0bb971a7e22f2a7ca8282aed536362bd968eae2fdc983d57dfc8f3d804b1aa

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DynamicIslandProfileButtonQuery$variables = Record<PropertyKey, never>;
export type DynamicIslandProfileButtonQuery$data = {
  readonly viewer: {
    readonly slugId: string;
    readonly " $fragmentSpreads": FragmentRefs<"UserPrimaryPhotoNew_user">;
  } | null | undefined;
};
export type DynamicIslandProfileButtonQuery = {
  response: DynamicIslandProfileButtonQuery$data;
  variables: DynamicIslandProfileButtonQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slugId",
  "storageKey": null
},
v1 = {
  "kind": "Literal",
  "name": "dpr",
  "value": 3
},
v2 = {
  "kind": "Literal",
  "name": "fo",
  "value": "auto"
},
v3 = {
  "kind": "Literal",
  "name": "h",
  "value": 100
},
v4 = {
  "kind": "Literal",
  "name": "w",
  "value": 100
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DynamicIslandProfileButtonQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserPrimaryPhotoNew_user"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DynamicIslandProfileButtonQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rowId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailMd5",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "primaryPhoto",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "fields": [
                      (v1/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "fit",
                        "value": "cover"
                      },
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/)
                    ],
                    "kind": "ObjectValue",
                    "name": "transform"
                  }
                ],
                "kind": "ScalarField",
                "name": "transformUrl",
                "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"fo\":\"auto\",\"h\":100,\"w\":100})"
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "fields": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "kind": "ObjectValue",
                "name": "transform"
              }
            ],
            "kind": "ScalarField",
            "name": "defaultAvatarUrl",
            "storageKey": "defaultAvatarUrl(transform:{\"dpr\":3,\"fo\":\"auto\",\"h\":100,\"w\":100})"
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "5b0bb971a7e22f2a7ca8282aed536362bd968eae2fdc983d57dfc8f3d804b1aa",
    "metadata": {},
    "name": "DynamicIslandProfileButtonQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8cd15b15a29f30591f090fdab8cbae37";

export default node;
